var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 32,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 10.8125C15.0781 10.8125 14.6875 11.2422 14.6875 11.75C14.6875 12.2969 15.0781 12.6875 15.625 12.6875C16.1328 12.6875 16.5625 12.2969 16.5625 11.75C16.5625 11.2422 16.1328 10.8125 15.625 10.8125ZM16.875 7.375V4.40625C16.875 3.9375 16.6406 3.42969 16.2891 3.07812L14.2969 1.08594C13.9453 0.734375 13.4375 0.5 12.9688 0.5H4.29688C3.63281 0.5 3.125 1.08594 3.125 1.75V7.375C1.36719 7.375 0 8.78125 0 10.5V15.5C0 15.8516 0.273438 16.125 0.625 16.125H3.125V19.875C3.125 20.2266 3.39844 20.5 3.75 20.5H16.25C16.5625 20.5 16.875 20.2266 16.875 19.875V16.125H19.375C19.6875 16.125 20 15.8516 20 15.5V10.5C20 8.78125 18.5938 7.375 16.875 7.375ZM5 2.375H12.5V4.25C12.5 4.60156 12.7734 4.875 13.125 4.875H15V7.375H5V2.375ZM15 18.625H5V16.125H15V18.625ZM18.125 14.25H1.875V10.5C1.875 9.83594 2.42188 9.25 3.125 9.25H16.875C17.5391 9.25 18.125 9.83594 18.125 10.5V14.25Z",
    fill: "#182722"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.85e3d7b5c63a997e3abcbc67e0872768.svg";
export { ForwardRef as ReactComponent };